// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1S8A4","colBig":"styles_colBig__hxqpJ","colSmall":"styles_colSmall__1Qh7z"};